<template>
  <Dialog :visible="visible" class="irinox-dialog-light print-dialog" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '550px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{ $t('spareParts.print.title') }}</div>
    </template>
    
    <div class="irinox-dialog-light-content layout-content">
      <div class="p-grid">
        <div class="p-col-6 p-field p-mb-1 p-pb-1">
          <label>{{ $t('spareParts.print.what') }}</label>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="singlePage" class="p-mr-2" :aria-label="$t('spareParts.print.what_single_page')" name="singlePage" :value="true" />
            <p>{{ $t('spareParts.print.what_single_page') }}</p>
          </div>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="singlePage" class="p-mr-2" :aria-label="$t('spareParts.print.what_full_document')" name="singlePage" :value="false" />
            <p>{{ $t('spareParts.print.what_full_document') }}</p>
          </div>
        </div>
        <div class="p-col-6 p-field p-mb-1 p-pb-1">
          <label>{{ $t('spareParts.print.content') }}</label>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="content" class="p-mr-2" :aria-label="$t('spareParts.print.content_ALL')" name="content" value="ALL" />
            <p>{{ $t('spareParts.print.content_ALL') }}</p>
          </div>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="content" class="p-mr-2" :aria-label="$t('spareParts.print.content_DRAWING')" name="content" value="DRAWING" />
            <p>{{ $t('spareParts.print.content_DRAWING') }}</p>
          </div>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="content" class="p-mr-2" :aria-label="$t('spareParts.print.content_LIST')" name="content" value="LIST" />
            <p>{{ $t('spareParts.print.content_LIST') }}</p>
          </div>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="content" class="p-mr-2" :aria-label="$t('spareParts.print.content_RECOMMENDED')" name="content" value="RECOMMENDED" />
            <p>{{ $t('spareParts.print.content_RECOMMENDED') }}</p>
          </div>
        </div>
        <div class="p-col-6 p-field p-mb-1 p-pb-1">
          <label>{{ $t('spareParts.print.type') }}</label>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="type" class="p-mr-2" :aria-label="$t('spareParts.print.type_PDF')" name="type" value="PDF" />
            <p>{{ $t('spareParts.print.type_PDF') }}</p>
          </div>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="type" class="p-mr-2" :aria-label="$t('spareParts.print.type_CSV')" name="type" value="CSV" />
            <p>{{ $t('spareParts.print.type_CSV') }}</p>
          </div>
        </div>
        <div class="p-col-6 p-field p-mb-1 p-pb-1">
          <label>{{ $t('spareParts.print.price') }}</label>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="price" class="p-mr-2" :aria-label="$t('spareParts.print.price_YES')" name="singlePage" :value="true" />
            <p>{{ $t('spareParts.print.price_YES') }}</p>
          </div>
          <div class="p-field-checkbox p-my-1">
            <RadioButton v-model="price" class="p-mr-2" :aria-label="$t('spareParts.print.price_NO')" name="singlePage" :value="false" />
            <p>{{ $t('spareParts.print.price_NO') }}</p>
          </div>
        </div>
      </div>
    </div>


    <template #footer>
      <Button :label="$t('spareParts.print.button')" @click="buttonClick" style="width: unset;"/>
    </template>
  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('details.dialog_error')"
    :life="5000" @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('spareParts.print.print_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import AfterSalesService from '../../../service/AfterSalesService';
import { mapGetters } from 'vuex';

export default {
    components: {
      IrinoxDialogDark,
    },
    emits: ['update:visible'],
    props: {
      visible: Boolean,
      spDocsId: Number,
      page: Number,
    },
    data() {
        return {
          singlePage: true,
          content: "ALL",
          type: "PDF",
          price: true,
          dialog: {
            error: false,
            success: false
          }
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
      }),
    },
    created() {
      this.afterSalesService = new AfterSalesService();
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.singlePage = true;
          this.content = "ALL";
          this.type = "PDF";
          this.price = true;
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {

        this.afterSalesService.printSp(this.personaltoken, this.spDocsId, this.singlePage ? this.page : null, this.content, this.type, this.price, this.$functions.language(this.$i18n.locale))
          .then((res) => {
            let httpType = "application/pdf";
            if(this.type == 'CSV') {
              httpType = "application/vnd.ms-excel";
            }
            let contentType = res.headers["content-type"];
            if(contentType !== 'application/json') {
              let filename = "spareParts_"+this.spDocsId+"_"+(this.$moment().format("YYYYMMDDHHmmss"))+"."+this.type.toLowerCase();
              let contentDisposition = res.headers["content-disposition"];
              if(contentDisposition) {
                filename = contentDisposition.replace(/.*filename="(.*)".*/g,"$1");
              }
              this.dialog.success = true;
              let blob=new Blob([res.data], {type: httpType});
              let link=document.createElement('a');
              link.href=window.URL.createObjectURL(blob);
              link.download=filename;
              link.click();
            } else {
              this.dialog.error = true;
              console.error("EXCEPTION "+JSON.stringify(res));
            }
          })  
          .catch(error => {
            console.error("ERROR " + error);
            this.dialog.error = true;
          })
          .finally(() => {
            this.updateVisible(false);
          });

      },
      show() {
        this.singlePage = true;
        this.content = "ALL";
        this.type = "PDF";
        this.price = true;
      },
    }
}
</script>

<style>

</style>